import { TimespanUnit } from '@debbie/common/dist/index.js';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import Input from './Input.js';
import Select from './Select.js';
const TimespanInput = (props) => {
    const lang = useSelector((s) => s.lang);
    const { disabled, value } = props;
    const min = props.min === undefined ? 0 : props.min;
    const units = props.units ??
        Object.values(TimespanUnit).filter((unit) => ![TimespanUnit.MS, TimespanUnit.Seconds].includes(unit));
    const [quantity, setQuantity] = useState(value[0]);
    useEffect(() => {
        if (quantity != value[0]) {
            setQuantity(value[0]);
        }
    }, [value[0]]);
    return (React.createElement(StyledTimespanInput, null,
        React.createElement(Input, { placeholder: lang.workflows.timespanUnitQuantity, disabled: disabled, type: "number", min: min ?? undefined, value: quantity, onChange: (e) => setQuantity(e.target.value), 
            // Commit on blur rather than per keystroke: consumers persist the
            // timespan directly, so typing "12" must not emit a transient 1.
            onBlur: () => {
                const parsed = parseInt(String(quantity));
                if (isNaN(parsed) || (min !== null && parsed < min)) {
                    setQuantity(value[0]);
                    return;
                }
                if (parsed !== value[0]) {
                    props.onChange([parsed, value[1]]);
                }
            } }),
        React.createElement(Select, { disabled: disabled, options: units.map((unit) => ({
                value: unit,
                label: lang.timespanUnits[unit],
            })), selected: [value[1]], onChange: (selected) => {
                const unit = selected[0];
                if (unit !== undefined) {
                    props.onChange([value[0], unit]);
                }
            } })));
};
export default TimespanInput;
const StyledTimespanInput = styled.div `
  display: flex;
  gap: 10px;
  align-items: flex-start;
  margin-bottom: 20px;

  && > .iris-input-container {
    width: 110px;
    flex: 0 0 auto;
    margin-bottom: 0;
  }

  && > *:last-child {
    flex: 1;
    min-width: 0;
    margin-bottom: 0;
  }
`;
//# sourceMappingURL=TimespanInput.js.map